import { render, staticRenderFns } from "./CustomFontFamilies.vue?vue&type=template&id=66d76fd2&"
import script from "./CustomFontFamilies.vue?vue&type=script&lang=ts&"
export * from "./CustomFontFamilies.vue?vue&type=script&lang=ts&"
import style0 from "./CustomFontFamilies.vue?vue&type=style&index=0&id=66d76fd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports